const geojsonData = {
  type: "FeatureCollection",

  features: [
    {
      type: "Feature",
      id: "sm6d47d7d5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047316371, 40.662156601],
            [-74.047231864, 40.6643123],
            [-74.047231864, 40.6643123],
            [-74.053828725, 40.664398907],
            [-74.053849969, 40.66230398],
            [-74.047316371, 40.662156601],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG08",
      },
    },
    {
      type: "Feature",
      id: "sm3ce7dde5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077130183, 40.649340707],
            [-74.079933357, 40.649368789],
            [-74.080834579, 40.64873386],
            [-74.080941868, 40.645559124],
            [-74.077196797, 40.645512874],
            [-74.077130183, 40.649340707],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG21",
      },
    },
    {
      type: "Feature",
      id: "sm790282f3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077196797, 40.645512874],
            [-74.073301405, 40.645464768],
            [-74.073234632, 40.649301681],
            [-74.077130183, 40.649340707],
            [-74.077196797, 40.645512874],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG20",
      },
    },
    {
      type: "Feature",
      id: "sm5d8ab5e7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.073301405, 40.645464768],
            [-74.069692192, 40.645420196],
            [-74.069625272, 40.649265522],
            [-74.073234632, 40.649301681],
            [-74.073301405, 40.645464768],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG19",
      },
    },
    {
      type: "Feature",
      id: "sma80e8413",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069692192, 40.645420196],
            [-74.065869015, 40.645372981],
            [-74.06580194, 40.649227219],
            [-74.069625272, 40.649265522],
            [-74.069692192, 40.645420196],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG18",
      },
    },
    {
      type: "Feature",
      id: "sm29b1c001",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065869015, 40.645372981],
            [-74.062303274, 40.645328946],
            [-74.062236055, 40.649191495],
            [-74.06580194, 40.649227219],
            [-74.065869015, 40.645372981],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG17",
      },
    },
    {
      type: "Feature",
      id: "sm6fa5a160",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.062303274, 40.645328946],
            [-74.058438891, 40.645281223],
            [-74.058371514, 40.649152779],
            [-74.062236055, 40.649191495],
            [-74.062303274, 40.645328946],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG16",
      },
    },
    {
      type: "Feature",
      id: "sm313b26ba",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.058438891, 40.645281223],
            [-74.054718174, 40.645235274],
            [-74.054588598, 40.647365436],
            [-74.054613305, 40.647366301],
            [-74.05457039, 40.648375693],
            [-74.055557442, 40.649124587],
            [-74.058371514, 40.649152779],
            [-74.058438891, 40.645281223],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG15",
      },
    },
    {
      type: "Feature",
      id: "sm37d4e327",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.054718174, 40.645235274],
            [-74.047982881, 40.645152096],
            [-74.047903149, 40.647186508],
            [-74.051824188, 40.647274975],
            [-74.051823807, 40.647268617],
            [-74.054588598, 40.647365436],
            [-74.054718174, 40.645235274],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG14",
      },
    },
    {
      type: "Feature",
      id: "smbb8aecd3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047903149, 40.647186508],
            [-74.047781126, 40.650299892],
            [-74.052653178, 40.650409811],
            [-74.05272503, 40.648717581],
            [-74.051866723, 40.647984962],
            [-74.051824188, 40.647274975],
            [-74.047903149, 40.647186508],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG13",
      },
    },
    {
      type: "Feature",
      id: "smc124067c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047781126, 40.650299892],
            [-74.047664681, 40.653270796],
            [-74.052527038, 40.653380491],
            [-74.052653178, 40.650409811],
            [-74.047781126, 40.650299892],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG12",
      },
    },
    {
      type: "Feature",
      id: "sm936422d6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047664681, 40.653270796],
            [-74.047555408, 40.656058614],
            [-74.052408667, 40.656168099],
            [-74.052527038, 40.653380491],
            [-74.047664681, 40.653270796],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG11",
      },
    },
    {
      type: "Feature",
      id: "smd072b4a9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047555408, 40.656058614],
            [-74.047441648, 40.658960777],
            [-74.052285049, 40.659079141],
            [-74.052408667, 40.656168099],
            [-74.047555408, 40.656058614],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG10",
      },
    },
    {
      type: "Feature",
      id: "sm69a581f2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047441648, 40.658960777],
            [-74.047316371, 40.662156601],
            [-74.053849969, 40.66230398],
            [-74.053851237, 40.662178976],
            [-74.05124445, 40.662163765],
            [-74.051180077, 40.661528958],
            [-74.052210045, 40.660845312],
            [-74.052285049, 40.659079141],
            [-74.047441648, 40.658960777],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG09",
      },
    },
    {
      type: "Feature",
      id: "sm5e07e00a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.053828725, 40.664398907],
            [-74.05786304, 40.664451872],
            [-74.057945688, 40.660456917],
            [-74.055021, 40.6604221],
            [-74.054012489, 40.661187136],
            [-74.054033947, 40.662180042],
            [-74.053851237, 40.662178976],
            [-74.053828725, 40.664398907],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG07",
      },
    },
    {
      type: "Feature",
      id: "smca28a2b8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05786304, 40.664451872],
            [-74.061592968, 40.66450084],
            [-74.06167571, 40.660501321],
            [-74.057945688, 40.660456917],
            [-74.05786304, 40.664451872],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG06",
      },
    },
    {
      type: "Feature",
      id: "sma1262ef6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061592968, 40.66450084],
            [-74.065294132, 40.664549431],
            [-74.065376967, 40.660545383],
            [-74.06167571, 40.660501321],
            [-74.061592968, 40.66450084],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG05",
      },
    },
    {
      type: "Feature",
      id: "sma822acca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.065294132, 40.664549431],
            [-74.069071003, 40.664599016],
            [-74.069153935, 40.660590346],
            [-74.065376967, 40.660545383],
            [-74.065294132, 40.664549431],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG04",
      },
    },
    {
      type: "Feature",
      id: "sm93634333",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069071003, 40.664599016],
            [-74.073021509, 40.66465088],
            [-74.073104541, 40.660637376],
            [-74.069153935, 40.660590346],
            [-74.069071003, 40.664599016],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG03",
      },
    },
    {
      type: "Feature",
      id: "smebe434cc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.073021509, 40.66465088],
            [-74.076633273, 40.664698297],
            [-74.076724946, 40.660680475],
            [-74.073104541, 40.660637376],
            [-74.073021509, 40.66465088],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG02",
      },
    },
    {
      type: "Feature",
      id: "sm3755debf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.076633273, 40.664698297],
            [-74.080705834, 40.664751763],
            [-74.080662918, 40.661561512],
            [-74.07963295, 40.660715093],
            [-74.076724946, 40.660680475],
            [-74.076633273, 40.664698297],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG01",
      },
    },
    {
      type: "Feature",
      id: "sm41758bb3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077566251, 40.650639196],
            [-74.07751468, 40.655050616],
            [-74.080920424, 40.655073532],
            [-74.080963325, 40.651403778],
            [-74.080963325, 40.651403778],
            [-74.079976272, 40.65067119],
            [-74.077566251, 40.650639196],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG22",
      },
    },
    {
      type: "Feature",
      id: "sm0a72c5cd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057765279, 40.654917731],
            [-74.057818361, 40.650377032],
            [-74.055450152, 40.650345593],
            [-74.05426998, 40.651110745],
            [-74.054158686, 40.654893464],
            [-74.057765279, 40.654917731],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG29",
      },
    },
    {
      type: "Feature",
      id: "sm64e9b6ae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057818361, 40.650377032],
            [-74.057765279, 40.654917731],
            [-74.060982535, 40.654939378],
            [-74.061035371, 40.65041974],
            [-74.057818361, 40.650377032],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG28",
      },
    },
    {
      type: "Feature",
      id: "sm769a7fff",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061035371, 40.65041974],
            [-74.060982535, 40.654939378],
            [-74.064202074, 40.654961041],
            [-74.064254664, 40.650462478],
            [-74.061035371, 40.65041974],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG27",
      },
    },
    {
      type: "Feature",
      id: "sm219aefc9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.064254664, 40.650462478],
            [-74.064202074, 40.654961041],
            [-74.067635793, 40.654984145],
            [-74.06768812, 40.650508059],
            [-74.064254664, 40.650462478],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG26",
      },
    },
    {
      type: "Feature",
      id: "smd4732afa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.06768812, 40.650508059],
            [-74.067635793, 40.654984145],
            [-74.070809756, 40.655005501],
            [-74.07086184, 40.650550192],
            [-74.06768812, 40.650508059],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG25",
      },
    },
    {
      type: "Feature",
      id: "smb4859b0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07086184, 40.650550192],
            [-74.070809756, 40.655005501],
            [-74.0741155, 40.655027744],
            [-74.074167331, 40.650594074],
            [-74.07086184, 40.650550192],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG24",
      },
    },
    {
      type: "Feature",
      id: "smb7d90267",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.074167331, 40.650594074],
            [-74.0741155, 40.655027744],
            [-74.07751468, 40.655050616],
            [-74.077566251, 40.650639196],
            [-74.074167331, 40.650594074],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG23",
      },
    },
    {
      type: "Feature",
      id: "sm6596739b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057612994, 40.659177544],
            [-74.057662804, 40.654917042],
            [-74.054158686, 40.654893464],
            [-74.054055404, 40.658403666],
            [-74.054999542, 40.659136169],
            [-74.057612994, 40.659177544],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG30",
      },
    },
    {
      type: "Feature",
      id: "sm6cda939f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077104209, 40.655047855],
            [-74.077052331, 40.6594853],
            [-74.079675865, 40.659526835],
            [-74.080877494, 40.658745502],
            [-74.080920424, 40.655073532],
            [-74.077104209, 40.655047855],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG37",
      },
    },
    {
      type: "Feature",
      id: "sm69e99f03",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077052331, 40.6594853],
            [-74.077104209, 40.655047855],
            [-74.07401607, 40.655027076],
            [-74.07396452, 40.659436415],
            [-74.077052331, 40.6594853],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG36",
      },
    },
    {
      type: "Feature",
      id: "sm00e14223",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07396452, 40.659436415],
            [-74.07401607, 40.655027076],
            [-74.070668556, 40.655004552],
            [-74.070617361, 40.659383424],
            [-74.07396452, 40.659436415],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG35",
      },
    },
    {
      type: "Feature",
      id: "sm650b8939",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070617361, 40.659383424],
            [-74.070668556, 40.655004552],
            [-74.067447874, 40.654982881],
            [-74.067397023, 40.659332441],
            [-74.070617361, 40.659383424],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG34",
      },
    },
    {
      type: "Feature",
      id: "smf523f01d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067397023, 40.659332441],
            [-74.067447874, 40.654982881],
            [-74.064017581, 40.6549598],
            [-74.063967095, 40.65927814],
            [-74.067397023, 40.659332441],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG33",
      },
    },
    {
      type: "Feature",
      id: "smf5511820",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.063967095, 40.65927814],
            [-74.064017581, 40.6549598],
            [-74.06079728, 40.654938132],
            [-74.060747137, 40.659227163],
            [-74.063967095, 40.65927814],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG32",
      },
    },
    {
      type: "Feature",
      id: "sm7ac021ec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.060747137, 40.659227163],
            [-74.06079728, 40.654938132],
            [-74.057662804, 40.654917042],
            [-74.057612994, 40.659177544],
            [-74.060747137, 40.659227163],
          ],
        ],
      },
      properties: {
        Unit_Number: "JG31",
      },
    },
  ],
};

export default geojsonData;
